import { COLOR_NEUTRAL_600 } from '@alltrails/denali/tokens';
import { POISubType } from '@alltrails/search/types/algoliaResultTypes';
import getPOIIcon from '@alltrails/search/utils/getPOIIcon';
import { createIconPinSvg, POIPinSize } from './svgMarkerComponents';

export const imageNamePrefix = 'poi-pin';
export const getImageName = (type: POISubType, size: POIPinSize) => `${imageNamePrefix}-${type}-${size}`;
const createPOIIconPinSvg = (type: POISubType, size: POIPinSize) =>
  createIconPinSvg(getImageName(type, size), getPOIIcon(type, true /* filled */), size, COLOR_NEUTRAL_600);

export default createPOIIconPinSvg;
